import { createContext } from 'react';
import { noop } from 'lodash';
import { AuthenticatedRedirectContextState } from '../model/AuthenticatedRedirectContextState';

export const AuthenticatedRedirectContext = createContext<AuthenticatedRedirectContextState>({
  redirectTo: undefined,
  setRedirectTo: noop,
  clearRedirectTo: noop,
  canRedirect: false,
  startRedirect: noop,
});
